import * as React from "react";
import { useSelector, useDispatch } from "react-redux";
import dialogIdGenerator from "~/components/Dialog/dialogIdGenerator";
import { actions as dialogActions, selectors as dialogSelectors } from "./store";
export interface DialogTriggerRenderProps {
    open: boolean;
    closeDialog(): void;
    openDialog(): void;
}
export type DialogControls = {
    isOpen: boolean;
    closeDialog: () => void;
    closeAllDialogs: () => void;
    openDialog: () => void;
};
export interface DialogTriggerProps {
    render: (props: DialogTriggerRenderProps) => React.ReactNode;
}
// eslint-disable-next-line jsdoc/require-param
/**
 * @deprecated Use workflows instead. See https://docs.octopushq.com/docs/frontend/workflows
 */
export function DialogTrigger(props: DialogTriggerProps) {
    const { closeAllDialogs, openDialog, isOpen } = useDialogTrigger();
    return (<React.Fragment>
            {props.render({
            openDialog,
            closeDialog: closeAllDialogs,
            open: isOpen,
        })}
        </React.Fragment>);
}
function useDialogId() {
    return React.useMemo(() => dialogIdGenerator.next(), []);
}
/**
 * @deprecated Use workflows instead. See https://docs.octopushq.com/docs/frontend/workflows
 */
export function useDialogTrigger(): DialogControls {
    const dialogId = useDialogId();
    const isOpen = useSelector((state: GlobalState) => dialogSelectors.createDialogOpenSelector(dialogId)(state));
    const dispatch = useDispatch();
    const openDialog = React.useCallback(() => dispatch(dialogActions.open(dialogId)), [dispatch, dialogId]);
    const closeDialog = React.useCallback(() => dispatch(dialogActions.close(dialogId)), [dispatch, dialogId]);
    const closeAllDialogs = React.useCallback(() => dispatch(dialogActions.closeAll()), [dispatch]);
    return { isOpen, openDialog, closeDialog, closeAllDialogs };
}
